import { 
    LOAD_STUDENT_HOUSING_PERIODS, 
    LOAD_STUDENT_HOUSING_PERIODS_ERROR, 
    LOAD_STUDENT_HOUSING_PERIODS_SUCCESS, 
    LOAD_STUDENT_MEAL_PLANS, 
    LOAD_STUDENT_MEAL_PLANS_ERROR, 
    LOAD_STUDENT_MEAL_PLANS_SUCCESS,
    STUDENT_LIFE_SEARCH_STUDENTS,
    STUDENT_LIFE_SEARCH_STUDENTS_ERROR,
    STUDENT_LIFE_SEARCH_STUDENTS_SUCCESS,
    STUDENT_LIFE_RESET_STUDENT_SEARCH_RESULTS,
    STUDENT_LIFE_RESET_ASSIGNED_MEALPLANS,
    STUDENT_LIFE_RESET_ASSIGNED_ROOMS
} from "./types";

const initialState = {
    studentMealPlans: [],
    studentHousingPeriods: [],
    searchResults: [],
    loading: {
        mealPlans: false,
        housingPeriods: false,
        search: false
    },
    error: {
        mealPlans: null,
        housingPeriods: null,
        search: null
    }
};

const studentStatusReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // Student Status - Meal Plans
        case LOAD_STUDENT_MEAL_PLANS:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    mealPlans: true
                },
                error: {
                    ...state.error,
                    mealPlans: null
                }
            };
        case LOAD_STUDENT_MEAL_PLANS_SUCCESS:
            return {
                ...state,
                studentMealPlans: payload,
                loading: {
                    ...state.loading,
                    mealPlans: false
                }
            };
        case LOAD_STUDENT_MEAL_PLANS_ERROR:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    mealPlans: false
                },
                error: {
                    ...state.error,
                    mealPlans: 'Failed to load student meal plans'
                }
            };
            
        // Student Status - Housing Periods
        case LOAD_STUDENT_HOUSING_PERIODS:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    housingPeriods: true
                },
                error: {
                    ...state.error,
                    housingPeriods: null
                }
            };
        case LOAD_STUDENT_HOUSING_PERIODS_SUCCESS:
            return {
                ...state,
                studentHousingPeriods: payload,
                loading: {
                    ...state.loading,
                    housingPeriods: false
                }
            };
        case LOAD_STUDENT_HOUSING_PERIODS_ERROR:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    housingPeriods: false
                },
                error: {
                    ...state.error,
                    housingPeriods: 'Failed to load student housing periods'
                }
            };

        // Student Search
        case STUDENT_LIFE_SEARCH_STUDENTS:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    search: true
                },
                error: {
                    ...state.error,
                    search: null
                }
            };
        case STUDENT_LIFE_SEARCH_STUDENTS_SUCCESS:
            return {
                ...state,
                searchResults: payload,
                loading: {
                    ...state.loading,
                    search: false
                }
            };
        case STUDENT_LIFE_SEARCH_STUDENTS_ERROR:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    search: false
                },
                error: {
                    ...state.error,
                    search: 'Failed to search students'
                }
            };
        case STUDENT_LIFE_RESET_STUDENT_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: []
            };
        case STUDENT_LIFE_RESET_ASSIGNED_MEALPLANS:
            return {
                ...state,
                studentMealPlans: []
            };
        case STUDENT_LIFE_RESET_ASSIGNED_ROOMS:
            return {
                ...state,
                studentHousingPeriods: []
            };                
        default:
            return state;
    }
}

export default studentStatusReducer;
